module.exports = __webpack_public_path__ + "img/pcbway.e1de8d14.png";